import Component from '../core/Component';

export default class Search extends Component {

    constructor($element) {
        super($element)
        this.$close = this.getRefElement('close')
    }

    prepare() {
        this.$close.on('click', ::this.close)
        $(document).on('click', event => {
            if ($('html').hasClass('show-search')) {
                event.preventDefault()
                event.stopPropagation()
                this.close()
            }
        })
        this.$element.on('click', event => event.stopPropagation())
        $(document).keyup((event) => {
            if (event.keyCode == 27) {
                this.close()
            }
        });

    }

    open () {
        $('html').addClass('show-search')
        var $input = this.$element.find('input[name=query]')
        $input.focus()
        var text = $input.val()
        $input.val('')
        $input.val(text)
    }

    close () {
        $('html').removeClass('show-search')
        this.$element.find('input[name=query]').blur()
    }
}


// WEBPACK FOOTER //
// ./components/Search.js